import React from 'react';

const Notfound = () => {
  return (
    <>
      <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
        <img 
          src="https://media.blogit.fr/output_mass/2017_10_10-08_54_39.38004.120.YLHdZudkK.png" 
          alt="Not Found" 
          style={{ maxWidth: "100%", height: "auto" }} 
        />
      </div>
    </>
  );
};

export default Notfound;

